import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { NOMINAS } from './types';

export const buscarNominas = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nominas/listar`, body, config);
        await dispatch({ type: NOMINAS.BUSCAR, payload: res.data.nominas });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const detallesNomina = (params) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(params);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nominas/detalles`, body, config);
        await dispatch({ type: NOMINAS.DETALLES, payload: res.data.nomina });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const crearNomina = (nominaData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(nominaData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nominas/crear`, body, config);
        await dispatch({ type: NOMINAS.AGREGAR, payload: res.data.nomina });
        await dispatch(setAlert(res.data.msg || 'Nómina creada correctamente', 'success'));
        return true;
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
        return false;
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const editarNomina = (nominaData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(nominaData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nominas/editar`, body, config);
        await dispatch({ type: NOMINAS.EDITAR, payload: res.data.nomina });
        await dispatch(setAlert(res.data.msg || 'Nómina editada correctamente', 'success'));
        return true;
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
        return false;
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarNomina = () => dispatch => {
    dispatch({ type: NOMINAS.LIMPIAR });
};
